var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { FelaComponent } from '@filou/core';
import Maps from './map';
var sortBy = require('lodash/sortBy');
var getDistance = function (lat1, lon1, lat2, lon2) {
    var p = 0.017453292519943295; // Math.PI / 180
    var c = Math.cos;
    var a = 0.5 -
        c((lat2 - lat1) * p) / 2 +
        (c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p))) / 2;
    return 12742 * Math.asin(Math.sqrt(a)); // 2 * R; R = 6371 km
};
var Map = /** @class */ (function (_super) {
    __extends(Map, _super);
    function Map() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeMarker: null,
            lat: 51.165691,
            lng: 10.451526,
            searchResult: {}
        };
        return _this;
    }
    Map.prototype.render = function () {
        var _this = this;
        var apiKey = this.props.apiKey;
        var _a = this.state, lat = _a.lat, lng = _a.lng, activeMarker = _a.activeMarker;
        var items = sortBy((this.props.items || []).filter(function (item) { return !!item.lat; }).map(function (item) { return (__assign({}, item, { distance: getDistance(item.lat, item.lng, lat, lng) })); }), 'distance');
        return (React.createElement(FelaComponent, { style: {
                width: '100%',
                // height: 500,
                display: 'block',
                position: 'absolute',
                top: 0,
                opacity: 0.2,
                // left: 0,
                height: '100%',
                zIndex: -1
            } },
            React.createElement(Maps, { center: { lat: lat, lng: lng }, zoom: 8, apiKey: apiKey }, items.map(function (_a, i) {
                var lat = _a.lat, lng = _a.lng, id = _a.id;
                return (React.createElement(Maps.Marker, { key: id || "" + lat + lng, lat: lat, lng: lng, active: activeMarker === (id || "" + lat + lng), onHover: function () {
                        return _this.setState({ activeMarker: id || "" + lat + lng });
                    } }));
            }))));
    };
    return Map;
}(React.Component));
export default Map;
//# sourceMappingURL=index.js.map